
import {getToken, setToken, removeToken,getUuid,setUuid,removeUuid} from '@/utils/auth'
import {resetRouter} from '@/router'
import {loginApi,findMenu} from '@/api/api'
import { Message } from 'element-ui'
import Layout from "@/layout/index";
import {encrypt} from "@/utils/md5";

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        icon: '',
        uuid:getUuid(),
        routers:sessionStorage.getItem('router')?JSON.parse(sessionStorage.getItem('router')):'',
        userInfo:{},
        permission:[],
        passwordExpired: false
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, icon) => {
        state.icon = icon
    },
    SET_UUID:(state,uuid)=>{
        state.uuid = uuid
    },
    SET_ROUTES:(state,routers)=>{
        state.routers = routers
    },
    SET_USERINFO:(state,userInfo)=>{
        state.userInfo = userInfo
    },
    SET_PERMISSION:(state,permission)=>{
        state.permission = permission
    },
    SET_PASSWORD_EXPIRED:(state,passwordExpired)=>{
        state.passwordExpired = passwordExpired
    },
}
function initMeta(routerD) {
    for(let i= 0;i <routerD.length;i++){
        if(routerD[i].meta){
            routerD[i].meta = JSON.parse(routerD[i].meta)
        }
        if(routerD[i].children){
            initMeta(routerD[i].children)
        }
    }
}

const actions = {
    // user login
    login({commit}, userInfo) {
        const {userName, passWord,yzm} = userInfo
        return new Promise((resolve, reject) => {
            loginApi({userName: encrypt(userName.trim()), passWord: encrypt(passWord),yzm:yzm}).then(response => {
                const {data} = response
               // console.log(data)
                if(response.state === '200'){
                    let userData = data.user || data;
                    let passwordExpired = data.passwordExpired || false;
                    userData.passWord = '';
                    userData.passWordOne = ''
                    userData.passWordTwo = '';
                    commit('SET_USERINFO', userData)
                    commit('SET_TOKEN', userData.id)
                    commit('SET_PASSWORD_EXPIRED', passwordExpired)
                    setToken(userData.id)
                    sessionStorage.setItem('isLogin',true)

                    findMenu({type:'1'}).then(result => {
                       // console.log(result)
                        let router1 = result.data.menu;
                        let permissionList = result.data.role,permission = [];
                        for(let i = 0;i < permissionList.length;i++){
                            if(permissionList[i]){
                                permission.push(permissionList[i].permissionCode)
                            }
                        }
                        commit('SET_PERMISSION',JSON.stringify(permission))
                        sessionStorage.setItem('permission',JSON.stringify(permission));
                        for(let i = 0;i < router1.length;i++){
                            if(router1[i].meta){
                                router1[i].meta = JSON.parse(router1[i].meta)
                            }
                            if(router1[i].children){
                                for(let j = 0;j < router1[i].children.length;j++){
                                    if(router1[i].children[j].meta){
                                        router1[i].children[j].meta = JSON.parse(router1[i].children[j].meta)
                                    }

                                    if(router1[i].children[j].children){
                                        let zChildren = router1[i].children[j].children
                                        for(let z =0;z < zChildren.length; z++){
                                            if(zChildren[z].meta){
                                                zChildren[z].meta = JSON.parse(zChildren[z].meta)
                                            }
                                        }
                                    }


                                }
                            }
                        }
                        let router2 = router1
                        commit('SET_ROUTES',JSON.stringify(router2))
                        sessionStorage.setItem('router',JSON.stringify(router2))
                        resolve()
                    })
                }else {
                    Message({
                        message: response.info || '未知异常！请重试，仍不能操作请联系管理员',
                        type: 'error',
                        duration: 2 * 1000
                    })
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            findMenu({type:'1'}).then(response => {
                if(response.state === '200'){
                    const {data} = response
                    if (!data) {
                        return reject('登录超时，请重新登录！')
                    }
                    let router1 = data.menu
                    let permissionList = data.role,permission = [];
                    for(let i = 0;i < permissionList.length;i++){
                        if(permissionList[i]){
                            permission.push(permissionList[i].permissionCode)
                        }
                    }
                    commit('SET_PERMISSION',JSON.stringify(permission))
                    sessionStorage.setItem('permission',JSON.stringify(permission));
                    for(let i = 0;i < router1.length;i++){
                        if(router1[i].meta){
                            router1[i].meta = JSON.parse(router1[i].meta)
                        }
                        if(router1[i].children){
                            for(let j = 0;j < router1[i].children.length;j++){
                                if(router1[i].children[j].meta){
                                    router1[i].children[j].meta = JSON.parse(router1[i].children[j].meta)
                                }
                                if(router1[i].children[j].children){
                                    let zChildren = router1[i].children[j].children
                                    for(let z =0;z < zChildren.length; z++){
                                        if(zChildren[z].meta){
                                            zChildren[z].meta = JSON.parse(zChildren[z].meta)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    let router2 = router1
                    //console.log(router2)
                    commit('SET_ROUTES',JSON.stringify(router2))
                    sessionStorage.setItem('router',JSON.stringify(router2))
                    resolve(data)
                }else {
                    removeToken()
                    removeUuid()
                    this.$router.replace({path:'/login'})
                    sessionStorage.clear();
                }

            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {

        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            removeUuid()
            commit('RESET_STATE')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}




// WEBPACK FOOTER //
// ./src/store/module/user.js